import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { dateOnlyBodyTemplate } from '../../../../utils/dateUtils';

const OtherLaborPriceTable = ({
    items,
    totalRecords,
    isLoading,
    page,
    pageSize,
    onPage,
    onEdit,
    onDelete
}) => {
    const { th } = useLanguage();

    const statusBodyTemplate = (rowData) => {
        // Check IsActive field from backend (PascalCase or camelCase)
        const isActive = rowData.IsActive === 1 || rowData.isActive === 1;

        const statusMap = {
            true: { label: th('common.active') || 'Aktif', severity: 'success' },
            false: { label: th('common.inactive') || 'Pasif', severity: 'danger' }
        };
        const status = statusMap[isActive] || statusMap.false;
        return <span className={`p-tag p-tag-${status.severity}`}>{status.label}</span>;
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="flex gap-1">
                <i
                    onClick={() => onEdit(rowData)}
                    className="pi pi-pencil cursor-pointer text-blue-500 hover:text-blue-700"
                    style={{ fontSize: '1.1rem' }}
                    title={th('common.edit') || 'Düzenle'}
                />
                <i
                    onClick={() => {
                        confirmDialog({
                            message:
                                th('otherLaborPrice.confirmDelete') ||
                                'Bu işçilik ücreti kaydını silmek istediğinize emin misiniz?',
                            header: th('common.confirm') || 'Onay',
                            icon: 'pi pi-exclamation-triangle',
                            acceptLabel: th('common.yes') || 'Evet',
                            rejectLabel: th('common.no') || 'Hayır',
                            accept: () => onDelete(rowData.id),
                            rejectClassName: 'p-button-outlined'
                        });
                    }}
                    className="pi pi-trash cursor-pointer text-red-500 hover:text-red-700"
                    style={{ fontSize: '1.1rem' }}
                    title={th('common.delete') || 'Sil'}
                />
            </div>
        );
    };

    const priceBodyTemplate = (rowData) => {
        if (!rowData.price) return '-';
        return rowData.price.toFixed(2);
    };

    return (
        <>
            <DataTable
                value={items}
                loading={isLoading}
                paginator
                rows={pageSize}
                first={(page - 1) * pageSize}
                totalRecords={totalRecords}
                onPage={onPage}
                rowsPerPageOptions={[10, 20, 50, 100]}
                emptyMessage={th('common.noRecordsFound') || 'Kayıt bulunamadı'}
                responsiveLayout="scroll"
                className="p-datatable-gridlines"
                showGridlines
            >
                <Column
                    header=""
                    body={actionBodyTemplate}
                    style={{ minWidth: '100px', textAlign: 'center' }}
                    exportable={false}
                />
                <Column
                    field="price"
                    header={th('otherLaborPrice.table.price') || 'Fiyat'}
                    body={priceBodyTemplate}
                    sortable
                    style={{ minWidth: '150px' }}
                />
                <Column
                    field="currency"
                    header={th('otherLaborPrice.table.currency') || 'Para Birimi'}
                    sortable
                    style={{ minWidth: '120px' }}
                />
                <Column
                    field="ContractStartDate"
                    header={th('otherLaborPrice.table.contractStartDate') || 'Başlangıç Tarihi'}
                    body={(rowData) => {
                        const date = dateOnlyBodyTemplate(rowData, 'ContractStartDate');
                        return date || '-';
                    }}
                    sortable
                    style={{ minWidth: '150px' }}
                />
                <Column
                    field="ContractEndDate"
                    header={th('otherLaborPrice.table.contractEndDate') || 'Bitiş Tarihi'}
                    body={(rowData) => {
                        const date = dateOnlyBodyTemplate(rowData, 'ContractEndDate');
                        return date || '-';
                    }}
                    sortable
                    style={{ minWidth: '150px' }}
                />
                <Column
                    field="isActive"
                    header={th('otherLaborPrice.table.status') || 'Durum'}
                    body={statusBodyTemplate}
                    style={{ minWidth: '120px' }}
                />
            </DataTable>
            <ConfirmDialog />
        </>
    );
};

export default OtherLaborPriceTable;

